export const EVENTS_MAP = {
  PHONE_DIALOG_OPEN: 'phone_dialog_open',
  PHONE_DIALOG_COPY: 'phone_dialog_copy',
  PHONE_DIALOG_CALL: 'phone_dialog_call',
  CALCULATOR_STEP_VIEW: 'calculator_step_view',
  CALCULATOR_ABANDONED: 'calculator_abandoned',
  CALCULATOR_CHALLENGE_SELECT: 'calculator_step1_challenge_select',
  CALCULATOR_SERVICES_SELECT: 'calculator_step2_services_select',
  CALCULATOR_SUBMIT_SUCCESS: 'calculator_submit_success',
  CALCULATOR_SUBMIT_FAILED_NETWORK: 'calculator_submit_failed_network',
  CALCULATOR_SUBMIT_ERROR: 'calculator_submit_error',
  CALENDAR_SECTION_VIEW: 'calendar_section_view',
  CALENDAR_BOOKING_LIKELY: 'calendar_booking_likely',
  CALENDAR_BOOKING_CONFIRMED: 'calendar_booking_confirmed',
  CTA_CLICK: 'cta_click',
  GENERATE_LEAD: 'generate_lead',
} as const;

export type EventName = (typeof EVENTS_MAP)[keyof typeof EVENTS_MAP];
